import Mixpanel from 'mixpanel';
import { Logger } from './AnalyticsInterface';
import { isServerSide } from './AnalyticsUtil';
import { getClientConfig } from '../Config/ClientConfig';
const browserMixPanel = require('mixpanel-browser');

export const MixpanelLogger: Logger = {
  name: 'Mixpanel',
  init: async () => {
    try {
      const { mixPanelToken } = await getClientConfig();
      browserMixPanel.init(mixPanelToken);
    } catch (e) {
      console.error('Error Initializing Mixpanel', e);
    }
  },
  identify: (superProps) => {
    if (isServerSide()) {
      return;
    }

    browserMixPanel.identify(superProps?.user_id || '');
    browserMixPanel.people.email = superProps?.email;
    browserMixPanel.people.set(superProps);
  },
  logEvent: (name, props) => {
    if (!props.karius_event) {
      return;
    }
    if (isServerSide()) {
      const mixpanel = Mixpanel.init(process.env.MIXPANEL_TOKEN!);
      mixpanel.track(name, props);
    } else {
      browserMixPanel.track(name, props);
    }
  },
  logError: (name, props) => {
    if (!props.karius_event) {
      return;
    }
    const finalProps = {
      error_title: name,
      ...props,
    };

    if (isServerSide()) {
      const mixpanel = Mixpanel.init(process.env.MIXPANEL_TOKEN!);
      mixpanel.track('error_logged', finalProps);
    } else {
      browserMixPanel.track('error_logged', finalProps);
    }
  },
};
